import { render, staticRenderFns } from "./AddContractItems.vue?vue&type=template&id=daa83d4c&scoped=true"
import script from "./AddContractItems.vue?vue&type=script&lang=js"
export * from "./AddContractItems.vue?vue&type=script&lang=js"
import style0 from "./AddContractItems.vue?vue&type=style&index=0&id=daa83d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa83d4c",
  null
  
)

export default component.exports